import React, { MouseEventHandler } from 'react';

export enum LoadingStatus {
  LOADING,
  SUCCESFUL,
  FAILED,
  IDLE,
}

interface StatusProps {
  status: LoadingStatus;
  feedbackText: string;
  onclick: MouseEventHandler<HTMLButtonElement>;
  children?: any;
}

const ButtonWithStatus: React.FC<StatusProps> = ({
  status,
  feedbackText,
  onclick,
  children = 'Datei hochladen',
}) => {
  const renderUploadStatus = () => {
    switch (status) {
      case LoadingStatus.LOADING:
        return (
          <>
            <span
              className="spinner-border ml-4"
              role="status"
            ></span>
            <span className="ml-2">{feedbackText}</span>
          </>
        );
      case LoadingStatus.FAILED:
        return (
          <span className="text-danger ml-4">{feedbackText}</span>
        );
      case LoadingStatus.SUCCESFUL:
        return (
          <span className="text-success ml-4">{feedbackText}</span>
        );
    }
    return <></>;
  };
  return (
    <>
      <div className="d-flex align-items-center mt-2">
        <button
          className="btn btn-primary"
          type="button"
          onClick={onclick}
        >
          {children}
        </button>
        {renderUploadStatus()}
      </div>
    </>
  );
};

export default ButtonWithStatus;
